import { render } from "./HoldOn.vue?vue&type=template&id=14d4b813&ts=true"
import script from "./HoldOn.vue?vue&type=script&lang=ts"
export * from "./HoldOn.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__